import { useState, useEffect, useCallback, useRef } from 'react';

export function useFetch(fetchFn, deps = [], options = {}) {
  const { immediate = true, initialData = null } = options;
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(immediate);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  const execute = useCallback(async (...args) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetchFn(...args);
      if (mountedRef.current) {
        setData(res.data.data);
        return res.data.data;
      }
    } catch (err) {
      if (mountedRef.current) {
        setError(err.response?.data?.message || 'Something went wrong');
      }
      throw err;
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, deps);

  useEffect(() => {
    if (immediate) execute();
  }, [immediate, ...deps]);

  return { data, loading, error, refetch: execute };
}
